module.exports = __webpack_public_path__ + "static/fipcbluewhale1-3a5aecc212600b4e0eb0e0509f8c4aea.jpeg";